/**
 * Какой пустой экран показать ленте вакансий (ТЗ 0071, п. 8.3).
 *
 *   saved        — включён только «сохранённые», а сохранённых нет;
 *   filtered     — в LearnIT вакансии есть, но фильтры отсекли все;
 *   empty_base   — вакансий в LearnIT нет вовсе: фильтры ни при чём, и
 *                  предлагать «сбросить фильтры» было бы неправдой.
 */
export type VacancyEmptyKind = 'saved' | 'filtered' | 'empty_base';

export const vacancyEmptyKind = ({
  savedOnlyIsTheOnlyFilter,
  totalAvailable,
}: {
  savedOnlyIsTheOnlyFilter: boolean;
  totalAvailable: number;
}): VacancyEmptyKind => {
  if (savedOnlyIsTheOnlyFilter) return 'saved';
  return totalAvailable > 0 ? 'filtered' : 'empty_base';
};
